import { persistReducer } from 'redux-persist';

import storage from 'redux-persist/lib/storage';

export const actionTypes = {
    Login: '[Login] Action',
    Logout: '[Logout] Action',
};
const initialAuthState = {
    user: undefined,
    data: undefined
};

export const reducer = persistReducer(
    {
        storage,
        key: 'k-care-auth',
        whitelist: ['user', 'data']
    },
    (state = initialAuthState, action) => {
        switch (action.type) {
            case actionTypes.Login: {
                const { data } = action.payload;
                return {
                    ...state,
                    data
                };
            }
            case actionTypes.Logout: {
                return initialAuthState;
            }
            default:
                return state;
        }
    }
);

export const actions = {
    login: (data) => ({ type: actionTypes.Login, payload: { data } }),
    // register: (authToken) => ({
    //     type: actionTypes.Register,
    //     payload: { authToken }
    // }),
    logout: () => ({ type: actionTypes.Logout }),
    // requestUser: (user) => ({
    //   type: actionTypes.UserRequested,
    //   payload: { user },
    // }),
    fulfillUser: (user) => ({ type: actionTypes.UserLoaded, payload: { user } }),
    setUser: (user) => ({ type: actionTypes.SetUser, payload: { user } })
};
